/* eslint-disable */
import airbrake from 'utils/airbrake';
import Units from 'utils/units';
import {
  precisionRound,
  convertMillimetersToInches,
  MillimetersToInches
} from 'utils/units/helpers';

function hasClass(el, className) {
  var classAttribute = el.getAttribute('class');
  if (classAttribute == null) return false;
  var classes = classAttribute.split(' ');

  for (var i = 0; i < classes.length; i += 1)
    if (classes[i] === className) return true;

  return false;
}

function convertToCelsius(value) {
  return Math.round((value - 32) / 1.8);
}

function convertToFahrenheit(value) {
  return Math.round(value * 1.8 + 32);
}

function convertMetersToFeet(value, settings) {
  if (settings && !Number.isNaN(Number(settings.roundTo)))
    return Math.round((value * 3.281) / settings.roundTo) * settings.roundTo;

  return Math.round(value * 3.281);
}

function convertFeetToMeters(value, settings) {
  if (settings && !Number.isNaN(Number(settings.roundTo)))
    return Math.round(value / 3.281 / settings.roundTo) * settings.roundTo;

  return Math.round(value / 3.281);
}

function convertKilometersToMiles(value, settings) {
  if (settings && !Number.isNaN(Number(settings.roundTo)))
    return Math.round(value / 1.609 / settings.roundTo) * settings.roundTo;

  return Math.round(value / 1.609);
}

function convertMilesToKilometers(value, settings) {
  return Math.round(value * 1.609);
}

function convertCmToInches(value, settings) {
  if (settings && settings.shouldNotRound) return value * 0.3937;

  return Math.round(value * 0.3937);
}

function convertInchesToCm(value, settings) {
  if (settings && settings.shouldNotRound) return value / 0.3937;

  return Math.round(value / 0.3937);
}

function ConvertKphToMph(value, settings) {
  if (settings && !Number.isNaN(Number(settings.roundTo)))
    return Math.round((value * 0.6214) / settings.roundTo) * settings.roundTo;

  return Math.round(value * 0.6214);
}

function ConvertMphToKph(value, settings) {
  if (settings && !Number.isNaN(Number(settings.roundTo)))
    return Math.round(value / 0.6214 / settings.roundTo) * settings.roundTo;

  return Math.round(value / 0.6214);
}

function convertInchesToMillimeters(value, settings) {
  return Math.round(value / 0.03937);
}

function convertHectarsToAcres(value) {
  return Math.round(value * 2.471052);
}

function convertAcresToHectars(value) {
  return Math.round(value * 0.404686);
}

function replaceValuesInPhrase(phrase, settings) {
  var units = settings.units;
  var convert = settings.convert;
  var pattern = settings.pattern;

  var result = pattern.exec(phrase.textContent);
  while (result !== null) {
    if (!Number.isNaN(Number(result[1])))
      phrase.textContent = phrase.textContent.replace(
        result[0],
        convert(result[1]) + units
      );
    result = pattern.exec(phrase.textContent);
  }
}

function toggleBodyClasses(newUnits) {
  if (newUnits === 'Metric') {
    document.body.classList.add('units-metric');
    document.body.classList.remove('units-imperial');
  } else {
    document.body.classList.add('units-imperial');
    document.body.classList.remove('units-metric');
  }
}

function toggleSwitchButtons(newUnits, settings) {
  if (newUnits === 'Metric') {
    var buttons = settings.container.querySelectorAll(
      '.switch-units-radio[data-units=Metric]'
    );
    Array.prototype.forEach.call(buttons, function(button) {
      button.checked = true;
    });
  } else {
    var buttons = settings.container.querySelectorAll(
      '.switch-units-radio[data-units=Imperial]'
    );
    Array.prototype.forEach.call(buttons, function(button) {
      button.checked = true;
    });
  }
}

var selectors = [
  'span.temp',
  'span.tempu',
  'span.height',
  'span.heightfl',
  'span.heightu',
  'span.dist',
  'span.distu',
  'span.snow',
  'span.snowht',
  'span.snowu',
  'span.wind',
  'span.windu',
  'span.rain',
  'span.rainu',
  'span.phrase',
  '.units-area',
  '.units-text',
];
function convertContentInNodes(newUnits, settings) {
  var dataAttrName, otherAttrName;
  if (newUnits === 'Metric') {
    dataAttrName = 'data-conv-metric';
    otherAttrName = 'data-conv-imperial';
  } else {
    dataAttrName = 'data-conv-imperial';
    otherAttrName = 'data-conv-metric';
  }

  var nodes = settings.container.querySelectorAll(selectors.join(', '));
  for (var i = 0; i < nodes.length; i++) {
    var node = nodes[i];

    var value = node.textContent;
    if (value === '' || value === '-') continue;

    if (
      window.currentUnits !== newUnits &&
      !Object.hasOwnProperty.call(node.dataset, 'backup' + window.currentUnits)
    )
      node.dataset['backup' + window.currentUnits] = value;

    if (Object.hasOwnProperty.call(node.dataset, 'backup' + newUnits)) {
      node.textContent = node.dataset['backup' + newUnits];
      continue;
    }

    /* legacy */
    var altValue = node.getAttribute(dataAttrName);
    if (altValue != null) {
      node.setAttribute(otherAttrName, node.textContent);
      node.textContent = altValue;
      continue;
    }

    if (hasClass(node, 'temp')) {
      if (Number.isNaN(Number(value))) continue;

      if (newUnits === 'Metric') node.textContent = convertToCelsius(value);
      else node.textContent = convertToFahrenheit(value);
      continue;
    }

    if (hasClass(node, 'tempu')) {
      if (newUnits === 'Metric') node.textContent = 'C';
      else node.textContent = 'F';
      continue;
    }

    if (hasClass(node, 'height')) {
      if (Number.isNaN(Number(value))) continue;

      if (newUnits === 'Metric') node.textContent = convertFeetToMeters(value);
      else node.textContent = convertMetersToFeet(value);
      continue;
    }

    if (hasClass(node, 'units-area')) {
      if (Number.isNaN(Number(value))) continue;

      if (newUnits === 'Metric')
        node.textContent = convertAcresToHectars(value);
      else node.textContent = convertHectarsToAcres(value);
      continue;
    }

    if (hasClass(node, 'heightfl')) {
      if (Number.isNaN(Number(value))) continue;

      if (newUnits === 'Metric')
        node.textContent = convertFeetToMeters(value, { roundTo: 50 });
      else node.textContent = convertMetersToFeet(value, { roundTo: 100 });
      continue;
    }

    if (hasClass(node, 'heightu')) {
      if (newUnits === 'Metric') node.textContent = 'm';
      else node.textContent = 'ft';
      continue;
    }

    if (hasClass(node, 'dist')) {
      if (Number.isNaN(Number(value))) continue;

      if (newUnits === 'Metric')
        node.textContent = convertMilesToKilometers(value);
      else
        node.textContent = convertKilometersToMiles(value, {
          roundTo: 0.1,
        }).toFixed(1);
      continue;
    }

    if (hasClass(node, 'distu')) {
      if (newUnits === 'Metric') node.textContent = 'km';
      else node.textContent = 'miles';
      continue;
    }

    if (hasClass(node, 'snow')) {
      if (Number.isNaN(Number(value))) continue;

      if (newUnits === 'Metric')
        node.textContent = convertInchesToCm(value, {
          shouldNotRound: true,
        }).toFixed(1);
      else
        node.textContent = convertCmToInches(value, {
          shouldNotRound: true,
        }).toFixed(1);
      continue;
    }

    if (hasClass(node, 'snowht')) {
      if (Number.isNaN(Number(value))) continue;

      if (newUnits === 'Metric') node.textContent = convertInchesToCm(value);
      else node.textContent = convertCmToInches(value);
      continue;
    }

    if (hasClass(node, 'snowu')) {
      if (newUnits === 'Metric') node.textContent = 'cm';
      else node.textContent = 'in';
      continue;
    }

    if (hasClass(node, 'wind')) {
      if (Number.isNaN(Number(value))) continue;

      if (newUnits === 'Metric')
        node.textContent = ConvertMphToKph(value, { roundTo: 5 });
      else node.textContent = ConvertKphToMph(value, { roundTo: 5 });
      continue;
    }

    if (hasClass(node, 'windu')) {
      if (newUnits === 'Metric') node.textContent = 'km/h';
      else node.textContent = 'mph';
      continue;
    }

    if (hasClass(node, 'rain')) {
      if (Number.isNaN(Number(value))) continue;

      if (newUnits === 'Metric')
        node.textContent = convertInchesToMillimeters(value);
      else {
        value = MillimetersToInches(value);
        node.textContent = precisionRound(value, value < 0.1 ? 2 : 1);
      }
      continue;
    }

    if (hasClass(node, 'rainu')) {
      if (newUnits === 'Metric') node.textContent = 'mm';
      else node.textContent = 'in';
      continue;
    }

    if (hasClass(node, 'phrase')) {
      if (newUnits === 'Metric') {
        /* F -> C */
        replaceValuesInPhrase(node, {
          pattern: /([-\d.]+)(°|&deg;)F/g,
          convert: convertToCelsius,
          units: '°C',
        });

        /* in -> mm */
        replaceValuesInPhrase(node, {
          pattern: /([\d.]+)in/g,
          convert: convertInchesToMillimeters,
          units: 'mm',
        });

        /* mph -> km/h */
        replaceValuesInPhrase(node, {
          pattern: /([\d.]+) mph/g,
          convert: ConvertMphToKph,
          units: 'km/h',
        });

        /* mi -> km */
        replaceValuesInPhrase(node, {
          pattern: /([\d.]+) miles/g,
          convert: convertMilesToKilometers,
          units: ' km',
        });

        /* ft -> m */
        replaceValuesInPhrase(node, {
          pattern: /([\d.]+) ft/g,
          convert: convertFeetToMeters,
          units: ' m',
        });

        continue;
      }

      /* C -> F */
      replaceValuesInPhrase(node, {
        pattern: /([-\d.]+)(°|&deg;)C/g,
        convert: convertToFahrenheit,
        units: '°F',
      });

      /* mm -> in */
      replaceValuesInPhrase(node, {
        pattern: /([\d.]+)mm/g,
        convert: function(value) {
          return convertMillimetersToInches(value, {
            shouldNotRound: true,
          }).toFixed(1);
        },
        units: 'in',
      });

      /* km/h -> mph */
      replaceValuesInPhrase(node, {
        pattern: /([\d.-]+)( ?)k(?:m\/|p)h/g,
        convert: ConvertKphToMph,
        units: 'mph',
      });

      /* km -> miles */
      replaceValuesInPhrase(node, {
        pattern: /([\d.]+) km/g,
        convert: convertKilometersToMiles,
        units: ' miles',
      });

      /* m -> ft */
      replaceValuesInPhrase(node, {
        pattern: /([\d.]+)( ?)m(?:[^pi]|$)/g,
        convert: convertMetersToFeet,
        units: ' ft',
      });

      /* cm -> in */
      replaceValuesInPhrase(node, {
        pattern: /([\d.]+)cm/g,
        convert: function(value) {
          return convertCmToInches(value, { shouldNotRound: true }).toFixed(1);
        },
        units: ' in',
      });
    }
  }
}

function convertWindImagesOld(newUnits) {
  var pattern = /(.*windicons\/wind[A-Z-]+)(\d+)(imperial|metric)\.gif/;

  var imgs = document.getElementsByClassName('windimg');
  Array.prototype.forEach.call(imgs, function(img) {
    var result = pattern.exec(img.src);
    if (result === null) return;

    var value = Number(result[2]);
    var converted;

    if (newUnits === 'Metric') {
      /* 0 to 25 rounded by 1; 30 to 200 rounded by 5 */
      converted = ConvertMphToKph(value);
      if (converted > 25) converted = ConvertMphToKph(value, { roundTo: 5 });

      img.src = result[1] + converted + 'metric.gif';
      return;
    }

    converted = ConvertKphToMph(value, { roundTo: 5 });
    img.src = result[1] + converted + 'imperial.gif';
  });
}

function convertSwellImagesOld(newUnits) {
  var pattern = /(.*swellicons\/swell\.[A-Z-]+)\.(\d+)\.(imperial|metric)\.([\d-]+)\.gif/;

  var imgs = document.getElementsByClassName('swellimg');
  Array.prototype.forEach.call(imgs, function(img) {
    var result = pattern.exec(img.src);
    if (result === null) return;

    var value = Number(result[2]);
    var converted;

    if (newUnits === 'Metric') {
      /* 0 to 25 rounded by 1; 30 to 200 rounded by 5 */
      converted = convertFeetToMeters(value);
      if (converted > 25)
        converted = convertFeetToMeters(value, { roundTo: 5 });

      img.src = result[1] + '.' + converted + '.metric.' + result[4] + '.gif';
      return;
    }

    converted = convertMetersToFeet(value, { roundTo: 5 });
    img.src = result[1] + '.' + converted + '.imperial.' + result[4] + '.gif';
  });
}

var switchUnitsEvent = new CustomEvent('switchUnits', {
  detail: {
    originalUnits: 'Metric',
  },
});

function switchFCUnits(newUnits) {
  if (newUnits == window.currentUnits) return;

  toggleBodyClasses(newUnits);

  toggleSwitchButtons(newUnits, { container: document });
  convertContentInNodes(newUnits, { container: document });

  convertWindImagesOld(newUnits); /* legacy */
  convertSwellImagesOld(newUnits); /* legacy */

  window.currentUnits = newUnits;
  document.dispatchEvent(switchUnitsEvent);
}

function switchFCUnitsWithin(newUnits, settings) {
  var container = settings.container;

  toggleSwitchButtons(newUnits, { container: container });
  convertContentInNodes(newUnits, { container: container });
}

function changeUnits(newUnits) {
  if (newUnits == window.currentUnits) return;

  try {
    const isMetric = newUnits === 'Metric';

    const type = isMetric ? 'Metric' : 'Imperial';
    Units.change({
      temperature: type,
      length: type,
      speed: type,
    });
  } catch (e) {
    airbrake.notify(e);
  }
}

window.originalUnits = 'Metric';
window.currentUnits = 'Metric';
window.switchFCUnits = switchFCUnits;
window.switchFCUnitsWithin = switchFCUnitsWithin;
window.changeUnits = changeUnits;

export default function() {
  Units.onChange(() => {
    switchFCUnits(Units.current.length);
  });

  if (
    window.FCGON &&
    window.FCGON.initial_units &&
    window.FCGON.initial_units !== 'Metric'
  ) {
    changeUnits('Imperial');
  }

  Units.onChange(changes => {
    const isMetric = Units.length === "Metric"
    if (window.FCMAPS) FCMAPS.switchUnits(isMetric ? 'metric' : 'imperial');
    window.updateUnitsInCookieAndUser(isMetric ? "Metric" : "Imperial");
  });
}
